<template>
  <!-- <a-drawer -->
  <Drawer
    :title="title"
    :visible="showDrawer"
    @handleOk="handleSubmit"
    @handleCancel="handleDrawer"
  >
    <div id="components-back-top-demo-custom">
      <a-back-top :target="targetFu">
        <div class="ant-back-top-inner">
          <img class="img1" src="@/assets/topIcon.png" alt="" />
          <p>返回顶部</p>
        </div>
      </a-back-top>
    </div>

    <a-spin :spinning="confirmLoading">
      <div class="breadNav">
        <a-breadcrumb>
          <a-breadcrumb-item v-for="item in formItemList" :key="item.value"
            ><a :href="'#' + item.id">{{ item.text }}</a></a-breadcrumb-item
          >
        </a-breadcrumb>
        <!-- <a-anchor>
          <a-anchor-link
            v-for="item in formItemList"
            :key="item.value"
            :href="'#' + item.value"
            :title="item.text"
          />
        </a-anchor> -->
      </div>

      <a-form :form="form" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item label="是否作为母产品">
          <a-switch
            :disabled="canEdit"
            @change="onChange"
            v-decorator="[
              'isParent',
              { initialValue: false, valuePropName: 'checked' }
            ]"
          />
        </a-form-item>
        <a-form-item label="产品代码">
          <a-input
            :max-length="7"
            :disabled="title == '编辑' || canCodeEdit"
            v-decorator="[
              'fundCode',
              {
                rules: [
                  {
                    required: true,
                    validator: validatorFundCode,
                    trigger: 'blur'
                  }
                ]
              }
            ]"
            placeholder="请输入产品代码"
          ></a-input>
        </a-form-item>
        <a-form-item label="产品名称">
          <a-input
            :max-length="50"
            v-decorator="['fundName', validatorRules.fundName]"
            placeholder="请输入产品名称"
          ></a-input>
        </a-form-item>
        <a-form-item label="产品全称">
          <a-input
            :max-length="100"
            v-decorator="['fullName', validatorRules.fullName]"
            placeholder="请输入产品全称"
          ></a-input>
        </a-form-item>
        <a-form-item label="产品风险">
          <j-dict-select-tag
            type="list"
            v-decorator="['riskLevel', validatorRules.riskLevel]"
            :trigger-change="true"
            dictCode="riskLevel"
            placeholder="请选择"
          />
        </a-form-item>
        <!-- <a-form-item
          label="净值展示类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            type="list"
            v-decorator="['netValueType', validatorRules.netValueType]"
            :trigger-change="true"
            dictCode="netValueType"
            placeholder="请选择"
          />
        </a-form-item> -->
        <a-form-item label=" " :colon="false">
          <a-checkbox
            @change="expectedProChange"
            v-decorator="[
              'isExpectedPro',
              { initialValue: false, valuePropName: 'checked' }
            ]"
          >
            是否报价产品
          </a-checkbox>
          <div>
            注：若选择
            "产品报价"选项，即认为此产品有预期收益率的属性（产品报价只和预期收益率对应）。那么在“预期收益率管理”模块,选择产品时会出现这个产品。
          </div>
        </a-form-item>

        <a-form-item label="产品期限" v-show="showTerm">
          <a-input-number v-decorator="['productTerm']" :min="1" />
        </a-form-item>
        <a-form-item label="产品性质">
          <j-dict-select-tag
            type="list"
            v-decorator="['proNature', validatorRules.proNature]"
            :trigger-change="true"
            dictCode="proNature"
            placeholder="请选择"
          />
        </a-form-item>
        <a-form-item label="产品投资类型">
          <j-dict-select-tag
            type="list"
            v-decorator="['investType', validatorRules.investType]"
            :trigger-change="true"
            dictCode="investType"
            placeholder="请选择"
          />
        </a-form-item>
        <a-form-item label="产品开放日类型">
          <j-dict-select-tag
            type="list"
            v-decorator="['opendayType']"
            :trigger-change="true"
            dictCode="openDayType"
            placeholder="请选择"
          />
        </a-form-item>
        <a-form-item label="产品开放日">
          <j-dict-select-tag
            type="list"
            v-decorator="['openday']"
            :trigger-change="true"
            dictCode="productType"
            placeholder="请选择"
          />
        </a-form-item>
        <a-form-item label="绑定虚拟产品大类" v-if="!isParent">
          <a-select
            placeholder="请选择产品代码"
            style="width: 570px"
            show-search
            :allowClear="true"
            :showSearch="true"
            optionFilterProp="label"
            @change="value => handleChange(value)"
            v-decorator="['virtualType']"
          >
            <a-select-option
              v-for="(item, index) in virtualProductMessage"
              :key="item.fundCode + '_' + index"
              :label="item.fundCodeName"
            >
              {{ item.fundCodeName }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label=" " :colon="false" v-if="hasLock">
          <a-checkbox
            v-decorator="[
              'isLock',
              {
                initialValue: false,
                valuePropName: 'checked'
              }
            ]"
          >
            是否上锁
          </a-checkbox>
        </a-form-item>
        <a-form-item label="产品到期类型">
          <j-dict-select-tag
            type="list"
            v-decorator="['dueType']"
            :trigger-change="true"
            dictCode="dueType"
            placeholder="请选择"
          />
        </a-form-item>
        <a-form-item label="产品系列">
          <j-dict-select-tag
            type="list"
            v-decorator="['series']"
            :trigger-change="true"
            dictCode="series"
            placeholder="请选择"
          />
        </a-form-item>
        <!-- <a-form-item label="策略">
          <a-textarea v-decorator="['celueEn']"></a-textarea>
        </a-form-item>
        <a-form-item label="目标">
          <a-textarea v-decorator="['mubiaoEn']"></a-textarea>
        </a-form-item> -->
        <a-form-item
          v-for="(item, key) in formItemList"
          :key="key"
          :label="item.text"
        >
          <!-- <a-textarea ref="userName" v-decorator="[item.value]"></a-textarea> -->
          <div :id="item.id">
            <tinymce-editor
              ref="tinymceEditors"
              :teid="item.value"
              v-decorator="[item.value, { initialValue: '' }]"
            />
          </div>
        </a-form-item>
      </a-form>
    </a-spin>
    <!-- <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div> -->
  </Drawer>
</template>
<script>
import Drawer from '@/components/common/Drawer';
import tinymceEditor from '@/components/tools/tinymceEditor';
import { ajaxGetDictItems } from '@/api/api.js';
import { getAction, postAction } from '@/api/manage';
export default {
  data() {
    return {
      canCodeEdit: false,
      virtualMsg: {}, //虚拟产品信息
      visible: false,
      title: '新增',
      formItemList: [], // 表单配置项
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      canEdit: false,
      isParent: false,
      validatorRules: {
        netValueType: {
          rules: [
            {
              required: true,
              message: '请选择净值展示类型!'
            }
          ]
        },
        fundCode: {
          rules: [
            {
              required: true,
              message: '请输入产品代码!'
            }
          ]
        },
        fundName: {
          rules: [
            {
              required: true,
              message: '请输入产品名称!'
            }
          ]
        },
        fullName: {
          rules: [
            {
              required: true,
              message: '请输入产品全称!'
            }
          ]
        },
        investType: {
          rules: [
            {
              required: true,
              message: '请输入产品投资类型!'
            }
          ]
        },
        proNature: {
          rules: [
            {
              required: true,
              message: '请输入产品性质!'
            }
          ]
        },
        riskLevel: {
          rules: [
            {
              required: true,
              message: '请输入风险等级!'
            }
          ]
        },
        email: {
          rules: [
            {
              pattern: /^([\w]+\.*)([\w]+)@[\w]+\.\w{3}(\.\w{2}|)$/,
              message: '请输入正确的电子邮件!'
            }
          ]
        }
      },
      virtualProductMessage: [],
      showTerm: false, // 是否显示产品期限
      summaryList: [], //产品概况入参数组
      productInfo: {}, //编辑对象
      url: {
        summayry:
          process.env.VUE_APP_CMS_PRODUCT + '/product/fund/summary/dict',
        save: process.env.VUE_APP_CMS_PRODUCT + '/product/fund/save',
        virtual: process.env.VUE_APP_CMS_PRODUCT + '/product/fund/list/parent', //绑定虚拟产品
        fundVirtual:
          process.env.VUE_APP_CMS_PRODUCT + '/product/fund/parent/fund', //选择虚拟产品
        parentCode:
          process.env.VUE_APP_CMS_PRODUCT + '/product/fund/parent/code' //选择虚拟产品
      },
      hasLock: false,
      showDrawer: false
    };
  },
  components: {
    tinymceEditor,
    Drawer
  },
  created() {
    this.virtualProduct();
    this.ajaxGetDictItemsMessage();
  },
  methods: {
    targetFu() {
      return document.querySelector('.container');
    },
    handleSubmit() {
      this.handleOk();
    },
    handleDrawer() {
      this.showDrawer = !this.showDrawer;
    },

    //选择虚拟产品
    chooseVirtual(val) {
      postAction(this.url.fundVirtual, { fundCode: val.fundCode }).then(res => {
        if (res.success) {
          let record = res.result;
          this.form.setFieldsValue({
            investType: record.investType,
            proNature: record.proNature,
            riskLevel: record.riskLevel,
            dueType: record.dueType,
            openday: record.openday,
            virtualType: record.virtualType,
            series: record.series,
            opendayType: record.opendayType,
            isExpectedPro: record.isExpectedPro == 1 ? true : false,
            virtualType: val.fundName
          });
          // that.virtualMsg = res.result ? res.result : {};
        } else {
          this.$message.err(res.message);
        }
      });
    },
    add() {
      this.showDrawer = !this.showDrawer;
      this.canCodeEdit = false;
      this.productInfo = {};
      this.canEdit = false;
      this.$nextTick(() => {
        this.form.resetFields();
      });
    },
    edit(record) {
      this.form.resetFields();
      this.showDrawer = true;
      this.virtualProduct(); //绑定虚拟产品大类所有数据
      this.productInfo = record;
      this.isParent = record.isParent == 1 ? true : false;
      this.showTerm = record.isExpectedPro == 1 ? true : false;
      // if (!record || JSON.stringify(record) == '{}') {
      //   this.canEdit = false;
      // } else {
      this.canEdit = true;
      // }

      this.summaryList = [];
      let obj = record.summaryMap;

      this.$nextTick(() => {
        this.form.setFieldsValue({
          productTerm: record.productTerm,
          fullName: record.fullName,
          fundCode: record.fundCode,
          fundName: record.fundName,
          investType: record.investType,
          proNature: record.proNature,
          riskLevel: record.riskLevel,
          dueType: record.dueType,
          openday: record.openday,
          virtualType: record.virtualType,
          series: record.series,
          opendayType: record.opendayType,
          isParent: record.isParent == 1 ? true : false,
          isExpectedPro: record.isExpectedPro == 1 ? true : false,
          mubiaoEn: record.mubiaoEn,
          celueEn: record.celueEn,
          isLock: record.isLock == 1 ? true : false
        });
        Object.keys(obj).forEach(key => {
          this.form.setFieldsValue({
            [key]: obj[key]
          });
        });
      });
    },

    handleCancel() {
      this.visible = false;
    },
    ajaxGetDictItemsMessage() {
      postAction(this.url.summayry).then(res => {
        if (res.success) {
          this.formItemList = res.result ? res.result : [];
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //绑定虚拟产品大类数据
    virtualProduct() {
      let that = this;
      getAction(that.url.virtual, { pdFdFund: '' }).then(res => {
        if (res.success) {
          res.result.map(item => {
            item.fundCodeName = item.fundName + '/' + item.fundCode;
          });
          that.virtualProductMessage = res.result ? res.result : [];
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //母子产品开关
    onChange(checked) {
      this.isParent = checked;
      let val = this.form.getFieldValue('virtualType');
      if (val && val != '' && checked) {
        this.form.resetFields();
      }
      if (checked) {
        // this.canEdit = true;
        this.canCodeEdit = true;

        getAction(this.url.parentCode).then(res => {
          if (res.success) {
            this.form.setFieldsValue({
              fundCode: res.result
            });
          } else {
            this.$message.err(res.message);
          }
        });
      } else {
        this.form.setFieldsValue({
          fundCode: ''
        });
        this.canCodeEdit = false;
      }
    },
    handleOk() {
      const that = this;
      this.form.validateFields((err, values) => {
        let formData = { ...that.productInfo, ...values };
        // if (!values.isParent) {
        //   if (values.fundCode.length < 6) {
        //     this.$message.warning('产品代码不能小于6位');
        //     return;
        //   }
        //   let regs = /^[0-9]*$/;
        //   if (!regs.test(values.fundCode)) {
        //     this.$message.warning('产品代码只能为数字');
        //     return;
        //   }
        // }
        this.formItemList.forEach(item => {
          let obj = {
            summaryCode: '',
            content: '',
            fundCode: ''
          };
          obj.summaryCode = item.value;
          obj.content = values[item.value];
          obj.fundCode = formData.fundCode;
          let index = this.summaryList.findIndex(
            item => item.summaryCode == obj.summaryCode
          );
          if (obj.content && obj.content != '' && index == -1) {
            this.summaryList.push(obj);
          }
        });
        if (!err) {
          this.showTerm = false;

          formData.summaryList = this.summaryList;
          formData.isExpectedPro = values.isExpectedPro ? 1 : 0;
          formData.isParent = values.isParent ? 1 : 0;
          formData.isLock = values.isLock ? 1 : 0;
          this.summaryList.forEach(item => {
            delete formData[item.summaryCode];
          });

          this.$http
            .post(that.url.save, formData, {
              headers: { 'Content-Type': 'application/json; charset=utf-8' }
            })
            .then(res => {
              if (res.success) {
                this.$message.success(res.message);
                this.showDrawer = false;
                that.$emit('handleOk');
              } else {
                this.$message.error(res.message);
              }
            });
        }
      });
    },
    expectedProChange(e) {
      console.log(e);
      this.showTerm = e.target.checked;
    },
    handleSearch(value) {
      let arr = [];
      this.virtualProductMessage.forEach(item => {
        if (
          item.fundCode.indexOf(value) > -1 ||
          item.fundName.indexOf(value) > -1
        ) {
          arr.push(item);
        }
      });
      this.virtualProductMessage = arr;
    },
    handleChange(value) {
      if (value) {
        let code = value ? value.split('_')[0] : '';
        this.hasLock = value ? true : false;
        let target = this.virtualProductMessage.find(
          item => item.fundCode == code
        );
        this.chooseVirtual(target);
        this.virtualProduct();
      }
    },
    validatorFundCode(rule, value, callback) {
      if (!value || value == '') {
        callback(new Error('请输入产品代码'));
      } else {
        if (!this.isParent) {
          if (value.length < 6) {
            callback(new Error('产品代码不能小于6位'));
          }
          let regs = /^[0-9]*$/;
          if (!regs.test(value)) {
            callback(new Error('产品代码只能为数字'));
          }
        }
      }
      callback();
    }
  }
};
</script>
<style scoped>
.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
#components-back-top-demo-custom .ant-back-top {
  /* bottom: 211px;
  right: 78px; */
  position: fixed;
  bottom: 100px;
  right: 30px;
  height: 80px;
  width: 80px;
}
#components-back-top-demo-custom .ant-back-top-inner {
  text-align: center;
  width: 80px;
  height: 80px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px #eeeeee;
  padding-top: 10px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  color: #999999;
  margin-top: 10px;
}
#components-back-top-demo-custom .ant-back-top-inner img {
  display: inline-block;
  width: 35px;
  height: 19px;
  opacity: 1;
  margin-top: 7px;
  margin-bottom: 8px;
}
</style>
